import { format } from 'date-fns';

import { CS_API_ROLES } from '../../constants/roles';
import apiRequestActionCreator from '../apiRequestActionCreator';
import {
    addItem,
    deleteItem,
    emptyCollection,
    fetchCollection,
    fetchItem,
    updateItem,
} from '../collectionActions';

const paramsFunction = ({ params }) => ({
    ...params,
    date: params.date && format(new Date(params.date), 'yyyy-MM-dd'),
});

const fetchReleaseNotes = ({ category }) =>
    fetchCollection({
        apiCollectionName: `release-notes/${category.toLowerCase()}`,
        collectionActionName: `${category.toUpperCase()}_RELEASE_NOTES`,
    });

const emptyReleaseNotes = ({ category }) =>
    emptyCollection({
        collectionActionName: `${category.toUpperCase()}_RELEASE_NOTES`,
    });

const addReleaseNote = ({ category }) =>
    addItem({
        apiCollectionName: `release-notes/${category.toLowerCase()}`,
        itemActionName: `${category.toUpperCase()}_RELEASE_NOTE`,
        paramsFunction,
    });

const fetchReleaseNote = ({ category }) =>
    fetchItem({
        apiCollectionName: `release-notes/${category.toLowerCase()}`,
        itemActionName: `${category.toUpperCase()}_RELEASE_NOTE`,
    });

const updateReleaseNote = ({ category }) =>
    updateItem({
        apiCollectionName: `release-notes/${category.toLowerCase()}`,
        itemActionName: `${category.toUpperCase()}_RELEASE_NOTE`,
        paramsFunction,
    });

const deleteReleaseNote = ({ category }) =>
    deleteItem({
        apiCollectionName: `release-notes/${category.toLowerCase()}`,
        itemActionName: `${category.toUpperCase()}_RELEASE_NOTE`,
    });

const fetchUnreadReleaseNotes = () => {
    return apiRequestActionCreator({
        actionName: 'UNREAD_RELEASE_NOTES',
        params: {
            url: `release-notes/unread`,
        },
    });
};

export {
    addReleaseNote,
    deleteReleaseNote,
    emptyReleaseNotes,
    fetchReleaseNote,
    fetchReleaseNotes,
    fetchUnreadReleaseNotes,
    updateReleaseNote,
};

export const releaseNotesPermissions = {
    fetchReleaseNotes: CS_API_ROLES.RELEASE_NOTE_READ,
};
